import * as actionTypes from './actionTypes';
import { typeOperationService } from './services';
import { actionsModalError } from '@app/src/common/modalError';

const fetchTypeOperationRequest = () => ({
  type: actionTypes.FETCH_TYPE_OPERATION_REQUEST
});

const fetchTypeOperationSuccess = (data) => ({
  type: actionTypes.FETCH_TYPE_OPERATION_SUCCESS,
  data
});

const fetchTypeOperationFailure = () => ({
  type: actionTypes.FETCH_TYPE_OPERATION_FAILURE
});

export const clearTypeOperationData = () => ({
  type: actionTypes.CLEAR_TYPE_OPERATION_DATA
});

export const fetchTypeOperation = (categoryId: number): Function => {
  return async dispatch => {
    dispatch(fetchTypeOperationRequest());
    try {
      const data = await typeOperationService.get(categoryId);
      dispatch(fetchTypeOperationSuccess(data));
    } catch (e) {
      dispatch(fetchTypeOperationFailure());
      dispatch(actionsModalError.openModalError());
    }
  }
};
